import type { z } from 'zod/mini';

import type { devSettingsSchema } from './devSettings.schema';

export type DevSettings = z.infer<typeof devSettingsSchema>;

export const DEV_SETTINGS_STORAGE_KEY = 'dynamic-dev-settings';
